import type { UserResponse } from '@shared/schemas';

import type { SaveStatus } from '../../_shared/domain/user-draft.model';

/**
 * Redux state for the Users admin index. The loaded rows, the load lifecycle
 * (`error` holds a human-readable banner / snackbar message), and independent
 * delete and deactivate / reactivate lifecycles for the row actions. Every field
 * is serialisable.
 */
export interface UsersState {
  rows: UserResponse[];
  loading: boolean;
  error: string | null;
  deleteStatus: SaveStatus;
  archiveStatus: SaveStatus;
  /**
   * Why the last deactivate / reactivate failed. Its own field, not `error`:
   * `error` is what the table reads to say the list could not load, and a failed
   * action says nothing about the list (the Administrators index's PI-50).
   */
  archiveError: string | null;
}

export const initialState: UsersState = {
  rows: [],
  loading: false,
  error: null,
  deleteStatus: 'idle',
  archiveStatus: 'idle',
  archiveError: null,
};
